import { render, staticRenderFns } from "./w-4-1.vue?vue&type=template&id=58e37ec2"
import script from "./w-4-1.vue?vue&type=script&lang=js"
export * from "./w-4-1.vue?vue&type=script&lang=js"
import style0 from "./w-4-1.vue?vue&type=style&index=0&id=58e37ec2&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../website-admin/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports